import { Utente } from 'api'

import { createSyncable, RowBase } from '@/lib/sync-manager/helpers'
import {
  comparePullCheckpoints,
  initialPullCheckpoint,
  pullFromServer,
  type PullCheckpoint,
} from '@/lib/sync-manager/pull-checkpoint'
import type { DexieDatabase } from '@/db/local/dexie-db'

// Define a type that combines the Utente with RowBase requirements
type UtenteRow = Utente & RowBase

export const createUtentiSyncable = (db: DexieDatabase) =>
  createSyncable<UtenteRow, PullCheckpoint | Date>({
    db,
    name: 'utenti',
    pull: {
      batchSize: 200,
      initialCheckpoint: initialPullCheckpoint,
      compareCheckpoints: comparePullCheckpoints,
      handler: pullFromServer<UtenteRow>('utenti'),
    },
  })
